<template>
  <div class="courses-list">
    <div
      :class="{ 'banner-not-loaded': !course.image_path }"
      class="course-item"
      v-bind:style="{ 'background-image': 'url(' + course.image_path + ') '}"
    >
      <div v-if="this.isPreview" class="text-content">
        <ul style="display:inline-block;list-style-type:none;justify-content: center;">
          <li></li>
          <li style="float:none;display: list-item;">
            <a
              style="width:100%;"
              v-on:click="showModules(course)"
              href="#"
            >Acessar especialização {{course.name}}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.banner-not-loaded {
  border-style: dashed;
  border-color: #1abdde;
}
</style>




<script>
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  props: ["course", "isPreview"],
  data() {
    return {
      selectedFile: null,
      lessonEdit: {},
      bannerKey:0
    };
  },
  methods: {
    getBanner(image_path) {
      return require("../assets/files/" + image_path);
    },
    showModules() {
      if (!this.isPreview) {
        var course_id = this.course.id;
        router.push("/home/classes");
        this.$store.commit("change_course", this.course);
      }
    }
  }
};
</script>
